import { CloneUtility } from "../../utilities/clone";
export var ProjectionPropertyOrdering;
(function (ProjectionPropertyOrdering) {
    ProjectionPropertyOrdering[ProjectionPropertyOrdering["None"] = 0] = "None";
    ProjectionPropertyOrdering[ProjectionPropertyOrdering["Ascending"] = 1] = "Ascending";
    ProjectionPropertyOrdering[ProjectionPropertyOrdering["Descending"] = 2] = "Descending";
})(ProjectionPropertyOrdering || (ProjectionPropertyOrdering = {}));
var QueryFilter = /** @class */ (function () {
    function QueryFilter() {
        this.filterValue = undefined;
        this.skipOnNullOrEmpty = true;
    }
    QueryFilter.getQuery = function (propertyName, value, symbolOperator, type, isAnd, isLast, groupGuid, selectedForGrouping, requiresInterpolation) {
        if (isAnd === void 0) { isAnd = false; }
        if (isLast === void 0) { isLast = false; }
        if (groupGuid === void 0) { groupGuid = null; }
        if (selectedForGrouping === void 0) { selectedForGrouping = false; }
        if (requiresInterpolation === void 0) { requiresInterpolation = false; }
        return {
            filterProperty: { name: propertyName, type: type },
            filterOperator: { translatedSymbol: symbolOperator, requiresInterpolation: requiresInterpolation },
            filterValue: value,
            isAnd: isAnd,
            isLast: isLast,
            groupColor: null,
            groupGuid: groupGuid,
            selectedForGrouping: selectedForGrouping,
            skipOnNullOrEmpty: false,
            subscription: null
        };
    };
    QueryFilter.clone = function (x) {
        var clonedCopy = CloneUtility.clone(x);
        var result = new QueryFilter();
        result.filterOperator = clonedCopy.filterOperator;
        result.filterValue = clonedCopy.filterValue;
        result.isAnd = clonedCopy.isAnd;
        result.isLast = clonedCopy.isLast;
        result.selectedForGrouping = clonedCopy.selectedForGrouping;
        result.groupColor = clonedCopy.groupColor;
        result.groupGuid = clonedCopy.groupGuid;
        result.filterProperty = clonedCopy.filterProperty;
        return result;
    };
    return QueryFilter;
}());
export { QueryFilter };
var ItemSource = /** @class */ (function () {
    function ItemSource() {
        this.shouldCacheControls = false;
    }
    return ItemSource;
}());
export { ItemSource };
export var SourceType;
(function (SourceType) {
    SourceType[SourceType["Collection"] = 0] = "Collection";
    SourceType[SourceType["ODataUrl"] = 1] = "ODataUrl";
})(SourceType || (SourceType = {}));
export var DataType;
(function (DataType) {
    DataType[DataType["Default"] = 1] = "Default";
    DataType[DataType["Boolean"] = 2] = "Boolean";
    DataType[DataType["Number"] = 3] = "Number";
    DataType[DataType["Double"] = 4] = "Double";
    DataType[DataType["Color"] = 5] = "Color";
    DataType[DataType["Image"] = 6] = "Image";
    DataType[DataType["Date"] = 7] = "Date";
    DataType[DataType["Lookup"] = 8] = "Lookup";
    DataType[DataType["HeiricalLookup"] = 9] = "HeiricalLookup";
    DataType[DataType["Icon"] = 10] = "Icon";
    DataType[DataType["CustomTemplate"] = 11] = "CustomTemplate";
    DataType[DataType["DateTime"] = 12] = "DateTime";
    DataType[DataType["Button"] = 13] = "Button";
    DataType[DataType["Expander"] = 14] = "Expander";
    DataType[DataType["ComboBox"] = 15] = "ComboBox";
    DataType[DataType["Radio"] = 16] = "Radio";
})(DataType || (DataType = {}));
var SavedQueriesDataModel = /** @class */ (function () {
    function SavedQueriesDataModel(name, queryModel, queryFilters, queryId, createdById, createdForId, isSharedGlobally, dateCreated, columns, tempId) {
        this.name = name;
        this.queryModel = queryModel;
        this.queryFilters = queryFilters;
        this.queryId = queryId;
        this.isSharedGlobally = isSharedGlobally;
        this.dateCreated = dateCreated;
        this.createdById = createdById;
        this.createdForId = createdForId;
        this.columns = columns;
        this.tempId = tempId;
    }
    return SavedQueriesDataModel;
}());
export { SavedQueriesDataModel };
var PersistQueryRequest = /** @class */ (function () {
    function PersistQueryRequest(queries, queriesToRemove) {
        this.queries = queries;
        this.queriesToRemove = queriesToRemove;
    }
    return PersistQueryRequest;
}());
export { PersistQueryRequest };
var Query = /** @class */ (function () {
    function Query(queryId, queryName, description, isSharedGlobally, dateCreated, queryBody, createdById, columns, tempId) {
        this.queryId = queryId;
        this.queryName = queryName;
        this.description = description;
        this.isSharedGlobally = isSharedGlobally;
        this.dateCreated = dateCreated;
        this.queryBody = queryBody;
        this.createdById = createdById;
        this.columns = columns;
        this.tempId = tempId;
    }
    return Query;
}());
export { Query };
var GetQueriesRequest = /** @class */ (function () {
    function GetQueriesRequest(entityType) {
        this.entityType = entityType;
    }
    return GetQueriesRequest;
}());
export { GetQueriesRequest };
var GetAllQueriesRequest = /** @class */ (function () {
    function GetAllQueriesRequest(entityType) {
        this.entityType = entityType;
    }
    return GetAllQueriesRequest;
}());
export { GetAllQueriesRequest };
